class SoftHavenQuiz extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;this.dataset.ready='1';
    this.step=0;this.answers={};this.panels=[...this.querySelectorAll('[data-sh-quiz-step]')];
    this.progress=this.querySelector('[data-sh-quiz-progress]');
    this.querySelectorAll('[data-sh-answer]').forEach(btn=>btn.addEventListener('click',()=>this.choose(btn)));
    this.querySelectorAll('[data-sh-quiz-back]').forEach(btn=>btn.addEventListener('click',()=>this.go(Math.max(0,this.step-1))));
    this.go(0);this.dispatchEvent(new CustomEvent('sh:quiz-started',{bubbles:true}));window.dataLayer?.push({event:'quiz_started'});
  }
  choose(btn){this.answers[btn.dataset.key]=btn.dataset.value; if(this.step<this.panels.length-2)this.go(this.step+1);else this.finish();}
  go(i){this.step=i;this.panels.forEach((p,x)=>p.hidden=x!==i);if(this.progress)this.progress.style.setProperty('--sh-progress',`${Math.round(((i+1)/(this.panels.length-1))*100)}%`);}
  finish(){const result=this.panels[this.panels.length-1];this.panels.forEach(p=>p.hidden=true);result.hidden=false;this.step=this.panels.length-1;
    result.querySelectorAll('[data-sh-result-scent]').forEach(el=>el.textContent=this.answers.scent||'Unscented');
    this.dispatchEvent(new CustomEvent('sh:quiz-completed',{bubbles:true,detail:this.answers}));window.dataLayer?.push({event:'quiz_completed',...this.answers});}
}
if(!customElements.get('soft-haven-quiz'))customElements.define('soft-haven-quiz',SoftHavenQuiz);

class SoftHavenBundle extends HTMLElement{
  connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='1';this.button=this.querySelector('[data-sh-bundle-add]');this.button?.addEventListener('click',()=>this.add());}
  async add(){const ids=[...this.querySelectorAll('[data-sh-bundle-variant]')].map(x=>Number(x.value)).filter(Boolean);if(!ids.length)return;this.button.disabled=true;this.button.setAttribute('aria-busy','true');
    try{const r=await fetch(window.Shopify?.routes?.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:ids.map(id=>({id,quantity:1}))})});if(!r.ok)throw new Error('Cart add failed');document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));window.dataLayer?.push({event:'bundle_created',item_count:ids.length});window.location.href='/cart';}
    catch(e){console.error(e);this.querySelector('[data-sh-bundle-error]')?.removeAttribute('hidden');}
    finally{this.button.disabled=false;this.button.removeAttribute('aria-busy');}}
}
if(!customElements.get('soft-haven-bundle'))customElements.define('soft-haven-bundle',SoftHavenBundle);


class SoftHavenCauseDirectory extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;this.dataset.ready='1';
    this.input=this.querySelector('[data-sh-cause-search]');
    this.select=this.querySelector('[data-sh-cause-category]');
    this.cards=[...this.querySelectorAll('[data-sh-cause-card]')];
    this.empty=this.querySelector('[data-sh-cause-empty]');
    const update=()=>{
      const q=(this.input?.value||'').trim().toLowerCase();
      const category=(this.select?.value||'all').toLowerCase();
      let visible=0;
      this.cards.forEach(card=>{
        const text=(card.dataset.search||'').toLowerCase();
        const cardCategory=(card.dataset.category||'').toLowerCase();
        const show=(!q||text.includes(q))&&(category==='all'||cardCategory===category);
        card.hidden=!show;if(show)visible++;
      });
      if(this.empty)this.empty.hidden=visible!==0;
      this.dispatchEvent(new CustomEvent('sh:cause-filter',{bubbles:true,detail:{query:q,category,visible}}));
    };
    this.input?.addEventListener('input',update);
    this.select?.addEventListener('change',update);
    update();
  }
}
if(!customElements.get('soft-haven-cause-directory'))customElements.define('soft-haven-cause-directory',SoftHavenCauseDirectory);
